import { useEffect } from 'react';

export const pushEvent = (config: object) => {
  (window as Application).dataLayer ??= [];
  (window as Application).dataLayer.push(config);
};

export const useDataLayer = (config: object) =>
  useEffect(() => {
    pushEvent(config);
  }, [config]);
